module.exports = __webpack_public_path__ + "img/IntrusionATM.f975e27b.svg";